<template>
  <div class="leak-reviewed-table-cell">
    <custom-checkbox
      color='cold-marine'
      size="s"
      :value="reviewedValue"
      @input="updateReviewedValue">
    </custom-checkbox>
  </div>
</template>

<script>
import CustomCheckbox from '@/components/common/CustomCheckbox.vue';

export default {
  name: 'LeakReviewedTableCell',
  components: { CustomCheckbox },
  props: {
    allItems: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async updateReviewedValue() {
      await this.$emit('updateReviewedValue', { item: this.item });
    },
  },
  computed: {
    reviewedValue() {
      return this.allItems[this.item.id - 1]?.reviewed || false;
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';
.leak-reviewed-table-cell {
  z-index: 2;
  display: flex;
  align-items: center;
  margin-top: rem(-5);
  .checkbox-container {
    display: unset;
    margin-left: rem(25);
    .checkmark {
      border-color: var(--brand-primary-hover);
    }
  }
}
</style   >
